import { ReactElement } from 'react';

import { ProgressBarContainer } from './TransactionFlowStyles';
import { ProgressBar } from '../ProgressBar/ProgressBar';

type Props = {
  progress: number;
};

export function HeaderProgressBar(props: Props): ReactElement {
  return (
    <ProgressBarContainer>
      <ProgressBar progress={props.progress} />
    </ProgressBarContainer>
  );
}
